import React, { Component } from 'react';
import { Button, Carousel } from 'react-bootstrap';
import { history } from '../../../store';
import UniqueButton from './uniqueButton';

import './styles.css';

class HomePageCarousel extends Component {
  handleClick = (carousel) => {
    if (carousel.button_link.match(/^https?:.*/i)) {
      window.open(carousel.button_link, '_blank');
    } else {
      history.push(carousel.button_link);
    }
  }

  render() {
    const {
      height, carouselSpeed, carousels, isRedButton
    } = this.props;

    const mobileScreen = window.innerWidth < 480 && window.innerHeight < 1097;

    return (
      <Carousel indicators interval={carouselSpeed * 1000} style={ { height } }>
        {carousels.map((carousel, key) => (
          <Carousel.Item key={key}>
            <div
              className="carousel-image"
              style={{
                height,
                backgroundImage: `url(${mobileScreen && carousel.link.mobile_image ? carousel.link.mobile_image : carousel.link.image})`
              }}
              onClick={() => this.handleClick(carousel)}
            />
            <Carousel.Caption>
              <div id={`custom_carousel_content_id_${carousel.id}`} />
              {carousel.title && (
                <h3
                  id="carousel-title"
                  style={{
                    color: carousel.text_color,
                    textAlign: carousel.text_alignment
                  }}
                >
                  {carousel.title || ''}
                </h3>
              )}
              <p
                id="carousel-subtitle"
                style={{
                  color: carousel.text_color,
                  textAlign: carousel.text_alignment
                }}
              >
                {carousel.text || ''}
              </p>
              {carousel.button_label && (['Red', 'Yellow', 'White', 'Grey'].includes(carousel.button_color) ? (
                <div>
                  <Button
                    id="carousel-button"
                    className={isRedButton ? 'red-btn' : `${carousel.button_color.toLowerCase() || 'red'}-ghost-btn`}
                    style={{
                      float: carousel.text_alignment
                    }}
                    onClick={() => this.handleClick(carousel)}
                  >
                    {carousel.button_label}
                  </Button>
                </div>
              ) : (
                <UniqueButton
                  buttonColor={carousel.button_color}
                  buttonTextColorWhenHover={carousel.button_text_color_when_hover}
                  buttonLink={carousel.button_link}
                  buttonLabel={carousel.button_label}
                />))}
            </Carousel.Caption>
          </Carousel.Item>
        ))}
        ;
      </Carousel>
    );
  }
}

HomePageCarousel.defaultProps = {
  isRedButton: false
};

export default HomePageCarousel;



// WEBPACK FOOTER //
// ./src/components/common/home/home-page-carousel.jsx